import { AnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/model/AnaliseLaboratorial";
import { HistoricoAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/model/HistoricoAnaliseLaboratorial";
import { PaginaAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/model/PaginaAnaliseLaboratorial";
import { NaturezaAnalise } from "@/contexts/laboratorio/ensaioAnalise";
import { api } from "@/shared/api/api";
import { getBlob } from "@/shared/api/getBlob";

const BASE = "/requisicoes-analises-laboratoriais";

export interface ListarAnalisesLaboratoriaisParams {
  estabelecimentoId: number;
  dataColeta?: string;
  codigo?: string;
  produtoOrigemAnimalId?: number;
  page?: number;
}

export interface HistoricoAnalisesParams {
  estabelecimentoId: number;
  naturezaAnaliseOficial: NaturezaAnalise;
  produtoAutorizadoId?: number;
}

export const createAnaliseLaboratorialApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const submit = async (item: Omit<AnaliseLaboratorial, "id" | "situacao">) => {
    const { data } = await api.post<AnaliseLaboratorial>(BASE, item, {
      headers,
    });
    return data;
  };

  const cancelar = async (id: number, motivo: string) => {
    await api.patch(`${BASE}/${id}/cancelar`, { motivo }, { headers });
  };

  const getById = async (id: number) => {
    const { data } = await api.get<AnaliseLaboratorial>(`${BASE}/${id}`, {
      headers,
    });
    return data;
  };

  const list = async ({
    estabelecimentoId,
    dataColeta,
    codigo,
    produtoOrigemAnimalId,
    page = 1,
  }: ListarAnalisesLaboratoriaisParams) => {
    const { data } = await api.get<PaginaAnaliseLaboratorial>(BASE, {
      params: {
        estabelecimentoId,
        dataColeta,
        codigo,
        produtoOrigemAnimalId,
        size: 20,
        page: page - 1,
      },
      headers,
    });
    return data;
  };

  const submitCertificado = async (
    requisicaoId: number,
    formData: FormData
  ) => {
    const { data } = await api.patch(
      `${BASE}/${requisicaoId}/certificado`,
      formData,
      {
        headers: { ...headers, "Content-Type": "multipart/form-data" },
      }
    );
    return data;
  };

  const getAnexo = (nomeUpload: string) =>
    getBlob(`${BASE}/anexo/${nomeUpload}`, { headers });

  const getHistorico = async (params: HistoricoAnalisesParams) => {
    const { data } = await api.get<HistoricoAnaliseLaboratorial[]>(
      `${BASE}/historico`,
      { params, headers }
    );
    return data;
  };

  return {
    submit,
    cancelar,
    getById,
    list,
    submitCertificado,
    getAnexo,
    getHistorico,
  };
};
